export default "__VITE_ASSET__DRkTZI_4__"